customElements.whenDefined('shopify-account').then(() => {
  document.querySelectorAll('shopify-account').forEach((el) => {
    if (!el.shadowRoot) return;

    const style = document.createElement('style');
    style.textContent = `
      .account {
        background: #F9F5E3;
      }
      .account .account__header {
        background: #F9F5E3;
      }
      .account__heading {
        font-family: var(--font-helvet) !important;
        font-weight: 700 !important;
        color: var(--color-brand-blue) !important;
        font-size: var(--text-xl) !important; 
        line-height: var(--text-xl-line-height) !important;
      }
    `;
    el.shadowRoot.appendChild(style);
  });
});

customElements.whenDefined('shopify-account').then(() => {
  function injectEmailInputStyle(shadowRoot) {
    if (shadowRoot.querySelector('style[data-tr-email-input]')) return;
    const style = document.createElement('style');
    style.setAttribute('data-tr-email-input', '');
    style.textContent = `
      #login-form-email {
        background-color: #fff !important;
      }
      label.login-form__marketing-consent span.login-form__marketing-consent-visual {
        background-color: #fff !important;
        border: 1px solid #00253E !important;
        border-radius: 2px !important;
      }
      label.login-form__marketing-consent span.login-form__marketing-consent-visual svg {
        border: 1px solid #fff !important;
        background-color: #fff !important;
        outline-width: 1px !important;
        outline-color: #fff !important;
        outline-style: solid !important;
        border-radius: 2px !important;
      }
    `;
    shadowRoot.appendChild(style);
  }

  document.querySelectorAll('shopify-account').forEach((el) => {
    if (!el.shadowRoot) return;

    const tryInject = () => {
      const form = el.shadowRoot.querySelector('shopify-login-form');
      if (form?.shadowRoot) injectEmailInputStyle(form.shadowRoot);
    };

    tryInject();

    new MutationObserver(tryInject).observe(el.shadowRoot, { childList: true, subtree: true });
  });
});